/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PCPSameAsReferrer } from "./PCPSameAsReferrer";
import type { ProviderDetails } from "./ProviderDetails";
import type { ProviderSkipped } from "./ProviderSkipped";

export interface CareTeamResponse {
  pcp: ProviderDetails | ProviderSkipped | PCPSameAsReferrer;
  referral: ProviderDetails | ProviderSkipped;
}
